export const DefaultRPnLPositive = '#43984d';
export const DefaultRPnLNegative = '#bd3f3b';
export const DefaultUPnLPositive = '#43984d';
export const DefaultUPnLNegative = '#bd3f3b';
